import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="bg-light py-3" style={{position:"fixed",bottom:"0",width:"100%",zIndex:"100"}}>
        <Container fluid={true}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © TSUL</Col>
            <Col md={6}>
              <div className="text-sm-right d-none d-sm-block">
                Design & Develop by EUM
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}
export default Footer
